import { useCallback, useState } from "react";
import { Button, ButtonThemeEnum } from "../shared/Buttons/styles";
import { useSecurity } from "../../hooks/api/admin/useSecurity";
import { SPACING } from "../../constants/design/spacing";
import useScreenSize from "../../hooks/api/screenSize/useScreenSize";
import { MobileDirectory } from "../shared/MobileDirectory";

export function Security() {
  const { isMobileScreen } = useScreenSize();
  const {
    pauseInstrument,
    resumeInstrument,
    resumeAllInstruments,
    pauseTrading,
    resumeTrading,
    pauseWithdraw,
    resumeWithdraw,
  } = useSecurity();

  const [instrumentName, setInstrumentName] = useState<string>("");
  const [withdrawTarget, setWithdrawTarget] = useState<string>("");

  const onPauseInstrument = useCallback(async () => {
    if (instrumentName) await pauseInstrument(instrumentName);
  }, [instrumentName, pauseInstrument]);

  const onResumeInstrument = useCallback(async () => {
    if (instrumentName) await resumeInstrument(instrumentName);
  }, [instrumentName, resumeInstrument]);

  const onPauseWithdraw = useCallback(async () => {
    if (withdrawTarget) await pauseWithdraw(withdrawTarget);
  }, [pauseWithdraw, withdrawTarget]);

  const onResumeWithdraw = useCallback(async () => {
    if (withdrawTarget) await resumeWithdraw(withdrawTarget);
  }, [resumeWithdraw, withdrawTarget]);

  const rowStyle: React.CSSProperties = {
    display: "flex",
    gap: SPACING.two,
    alignItems: isMobileScreen ? "stretch" : "center",
    flexDirection: isMobileScreen ? "column" : "row",
    width: "100%",
  };

  return (
    <div style={{ padding: isMobileScreen ? SPACING.two : SPACING.four }}>
      {isMobileScreen ? (
        <div style={{ marginBottom: SPACING.two }}>
          <MobileDirectory />
        </div>
      ) : null}
      <div style={{ marginBottom: SPACING.four }}>
        <h2>Trading</h2>
        <div style={rowStyle}>
          <Button
            buttonTheme={ButtonThemeEnum.NEUTRAL2}
            onClick={pauseTrading}
            style={isMobileScreen ? { width: "100%" } : undefined}
          >
            Pause Trading
          </Button>
          <Button
            buttonTheme={ButtonThemeEnum.NEUTRAL2}
            onClick={resumeTrading}
            style={isMobileScreen ? { width: "100%" } : undefined}
          >
            Resume Trading
          </Button>
        </div>
      </div>

      <div style={{ marginBottom: SPACING.four }}>
        <h2>Instrument</h2>
        <div style={rowStyle}>
          <input
            name="instrumentName"
            placeholder="Enter instrument name (e.g., ETH-PERP)"
            value={instrumentName}
            onChange={(e) => setInstrumentName(e.target.value)}
            style={{ width: isMobileScreen ? "100%" : 420 }}
          />
          <Button
            buttonTheme={ButtonThemeEnum.NEUTRAL2}
            disabled={!instrumentName}
            onClick={onPauseInstrument}
            style={isMobileScreen ? { width: "100%" } : undefined}
          >
            Pause Instrument
          </Button>
          <Button
            buttonTheme={ButtonThemeEnum.NEUTRAL2}
            disabled={!instrumentName}
            onClick={onResumeInstrument}
            style={isMobileScreen ? { width: "100%" } : undefined}
          >
            Resume Instrument
          </Button>
          <Button
            buttonTheme={ButtonThemeEnum.NEUTRAL2}
            onClick={resumeAllInstruments}
            style={isMobileScreen ? { width: "100%" } : undefined}
          >
            Resume All Instruments
          </Button>
        </div>
      </div>

      <div>
        <h2>Withdrawals</h2>
        <div style={rowStyle}>
          <input
            name="withdrawTarget"
            placeholder="all or 0x..."
            value={withdrawTarget}
            onChange={(e) => setWithdrawTarget(e.target.value)}
            style={{ width: isMobileScreen ? "100%" : 420 }}
          />
          <Button
            buttonTheme={ButtonThemeEnum.NEUTRAL2}
            disabled={!withdrawTarget}
            onClick={onPauseWithdraw}
            style={isMobileScreen ? { width: "100%" } : undefined}
          >
            Pause Withdrawals
          </Button>
          <Button
            buttonTheme={ButtonThemeEnum.NEUTRAL2}
            disabled={!withdrawTarget}
            onClick={onResumeWithdraw}
            style={isMobileScreen ? { width: "100%" } : undefined}
          >
            Resume Withdrawals
          </Button>
        </div>
      </div>
    </div>
  );
}
